import { useState } from "react";
import { Link } from "react-router-dom";
import { Play, Star, X } from "lucide-react";
import { TESTIMONIALS } from "../../data/homeData";
import SmartImg from "../ui/SmartImg";

const Testimonials = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section
      id="student-life"
      data-testid="testimonials-section"
      className="py-20 bg-white"
    >
      <div className="ac-container">
        <div className="text-center mb-12">
          <div className="eyebrow">Success Stories</div>
          <h2 className="section-heading mt-3" data-testid="testimonials-heading">
            Hear What Students Say
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <button
              key={t.name}
              onClick={() => setActiveVideo(t.videoId)}
              className="group relative overflow-hidden rounded-xl aspect-[16/10] sm:aspect-[3/4] bg-[var(--ac-navy)] lift text-left"
              data-testid={`testimonial-${i}`}
            >
              <SmartImg
                src={t.img}
                alt={t.name}
                className="absolute inset-0 w-full h-full object-cover opacity-95 group-hover:scale-105 transition-transform duration-500"
                style={{ objectPosition: "center top" }}
                loading="lazy"
                decoding="async"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[var(--ac-red)] group-hover:bg-[var(--ac-red)] group-hover:text-white transition-all shadow-lg">
                <Play className="w-5 h-5 ml-0.5" fill="currentColor" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                <div className="flex gap-0.5 mb-2 text-[#f5c056]">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} className="w-3.5 h-3.5" fill="currentColor" />
                  ))}
                </div>
                <div className="font-bold text-[17px]">{t.name}</div>
                <div className="text-xs text-white/85 mt-0.5">{t.program}</div>
              </div>
            </button>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/why-anderson/testimonials"
            className="ds-btn ds-btn--secondary"
            data-testid="testimonials-show-more"
          >
            Show More
          </Link>
        </div>
      </div>

      {/* Video modal */}
      {activeVideo && (
        <div
          className="fixed inset-0 z-[100] bg-black/85 backdrop-blur flex items-center justify-center p-4 ac-fade-up"
          onClick={() => setActiveVideo(null)}
          data-testid="video-modal"
        >
          <button
            onClick={() => setActiveVideo(null)}
            className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white text-[var(--ac-ink)] flex items-center justify-center hover:bg-[var(--ac-red)] hover:text-white transition"
            data-testid="video-modal-close"
            aria-label="Close video"
          >
            <X className="w-5 h-5" />
          </button>
          <div
            className="w-full max-w-4xl aspect-video rounded-xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1&rel=0`}
              title="Student testimonial"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
